/*
 * Copyright (c) 2019 by Enrico Ansaloni <enrico.ansaloni@gmail.com>
 */

// core imports
//import * as React from "react";
import React, {lazy, Suspense} from "react";
import {Component} from "react";
import {Route, Switch, BrowserRouter, Link} from 'react-router-dom';
import AppController from './controllers/AppController';
// component imports
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
// internal imports
import Loading from "./components/loading/Loading";
const MainMenu = lazy( () => import('./components/mainmenu/MainMenu'));
const Home = lazy( () => import('./components/home/Home'));
const Admin = lazy( () => import('./components/admin/Admin'));
const Login = lazy( () => import('./components/login/Login'));
const Register = lazy( () => import('./components/register/Register'));
const Activate = lazy( () => import('./components/activate/Activate'));
const Footer = lazy( () => import('./components/footer/Footer'));
const UserDevices = lazy( () => import('./components/user/devices/UserDevices'));
const UserReportsMain = lazy( () => import('./components/user/reports/Reports'));

// i18n imports
import i18n from "./i18n";

// import style
import './App.scss';
import {Col} from "react-bootstrap";
//import BarcodeScanner from "./components/barcode/BarcodeScanner";
import OtpGenerator from "./components/otp/OtpGenerator";
export class App extends Component<{}, { forceRefresh: string, languageInitialized: boolean, languageOptions: any }> {

    appController: any = null;
    menuRef:any = null;

    constructor(props:any){
        super(props);

        // init app controller
        this.appController = new AppController();

        this.state = {
            forceRefresh: "no",
            languageInitialized: false,
            languageOptions: {}
        }
    };

    componentDidMount = () => {
        console.log("App.tsx: component mounted...");
        i18n.on('initialized', this.handleLanguageInitialized);
        i18n.on('languageChanged', this.handleLanguageChanged);
        this.appController.connectEvent("App", "onReportCreated", (data:any) => this.handleNewReport(data));
        this.appController.applyCurrentTheme();
        // setTimeout( () => {
        // }, 2000);
        // this.appController.connectEvent("App", "onUserCreated", (data:any) => this.handleNewUser(data));
    };

    componentWillUnmount = () => {
        console.log("App.tsx: component will unmount...");
        i18n.off('initialized', this.handleLanguageInitialized);
        i18n.off('languageChanged', this.handleLanguageChanged);
        this.appController.rest.abortRequest();
        this.appController.disconnectEventsForScope("App");
    };

    handleLanguageInitialized = (options:any) => {
        console.log(`App.tsx: handleLanguageInitialized: language initialized: languages: ${JSON.stringify(options.preload)}`);
        this.appController.setLocale(i18n.language);
        this.setState({
            languageInitialized: true,
            languageOptions: options
        })
    };

    handleLanguageChanged = (lang:string) => {
        console.log(`App.tsx: handleLanguageChanged: language changed: ${lang}`);
        this.appController.setLocale(i18n.language);
        this.setState({
            forceRefresh: new Date().toISOString()
        });
    };

    handleLoggedUserSaved = async (user:string) => {
        console.log(`App.tsx: handleLoggedUserChanged: received user save event from UserEdit=>Admin, transmitting to MainMenu...`);
        await this.menuRef.saveUser(user);
    };

    handleNewReport = (data:any) => {
        console.log("App.tsx: handleNewReport: socket.io onReportCreated event received");
        if(this.appController.auth.isLoggedIn() && data && Object.keys(data).length > 0) {
            // toast.info(`New report created!`);
            const url = this.appController.auth.auth.isAdmin || this.appController.auth.auth.isManager ? `/admin/reports` : `/user/reports/${this.appController.auth.auth.userId}`;
            const Msg = () => (
                <div>
                    <Link to={url}>{`${i18n.t("New report created")}!`}</Link>
                </div>
            )
            toast.info(<Msg />);
        }
    }

    handleNewUser = (data:any) => {
        console.log("App.tsx: handleNewReport: socket.io onUserCreated event received");
        if(this.appController.auth.isLoggedIn() && data && Object.keys(data).length > 0) {
            //toast.info(`New user created!`);
            const Msg = () => (
                <div>
                    <Link to={`/admin/user/${data.document._id}`}>New user created!</Link>
                </div>
            )
            toast.info(<Msg />);
        }
    }

    render() {

        const CustomHeaderGraphics = () => {
            return (
                <div className="custom-header-graphics" />
            );
        }

        const App = () => (
            <Route
                render={({ location, history }) => (
                    <div id="app">
                        <ToastContainer position="top-right"
                                        autoClose={5000}
                                        hideProgressBar={false}
                                        newestOnTop={true}
                                        closeOnClick={true}
                                        limit={10}
                        />
                        <Login appController={this.appController} i18n={i18n}/>
                        <MainMenu ref={(ref:any) => this.menuRef = ref} appController={this.appController} i18n={i18n} location={location} history={history} languageOptions={this.state.languageOptions} />
                        {/*<CustomHeaderGraphics />*/}
                        <div key={location.pathname} className="d-flex flex-column flex-fill">
                            <Switch location={location}>
                                <Route exact path='/' render={
                                        ({ location, match, history }) => <Home appController={this.appController} i18n={i18n} location={location} match={match} history={history} />
                                    }
                                />
                                <Route path='/admin' render={
                                    ({ location }) => <Admin appController={this.appController} i18n={i18n} location={location} history={history} onLoggedUserSaved={this.handleLoggedUserSaved} />
                                }
                                />
                                <Route path='/register' render={
                                    ({ location }) => <Register appController={this.appController} i18n={i18n} location={location} />
                                }/>
                                <Route path='/activate/:token' render={
                                    ({ location, match, history }) => <Activate appController={this.appController} i18n={i18n} location={location} match={match} history={history} token={match.params.token} />
                                }/>
                                <Route path="/user/devices" render={
                                    ({location, match, history}) => (
                                        <Col>
                                            <UserDevices appController={this.appController} i18n={i18n} location={location} match={match} history={history} visible={true} />
                                        </Col>
                                    )
                                }
                                />
                                <Route path="/user/reports/:id" render={
                                    ({location, match, history}) => (
                                        <Col>
                                            <UserReportsMain app={this.appController} i18n={i18n} location={location} match={match} history={history} visible={true} />
                                        </Col>
                                    )
                                }
                                />
                                {/*<Route path="/barcode" render={
                                    () => (
                                        <Col className="d-flex flex-column flex-fill">
                                            <BarcodeScanner i18n={i18n} app={this.appController} />
                                        </Col>
                                    )
                                }
                                />*/}
                                <Route path="/otp" render={
                                    () => (
                                        <Col className="d-flex flex-column flex-fill">
                                            <OtpGenerator i18n={i18n} app={this.appController} />
                                        </Col>
                                    )
                                }
                                />
                            </Switch>
                        </div>
                        <Footer i18n={i18n}/>
                    </div>
                )}
            />
        );

        if(this.state.languageInitialized) {
            return (
                <BrowserRouter>
                    <Suspense fallback={<Loading i18n={i18n}/>}>
                        <App/>
                    </Suspense>
                </BrowserRouter>
            );
        } else {
            return (
                <Loading />
            )
        }
    };
}

export default App;
